<template lang="html">
  <div class="serve-info">
    <!-- <div class="order-address">
            <p class="order-address-f">
                <i class="order-address-icon"></i>
                <span >{{ worker.userName}}</span>
                <span class="order-address-phone">{{ worker.contact.replace(/(\d{3})\d*(\d{4})/,'$1****$2') }}</span>
            </p>
            <p class="order-address-s">地址：{{ worker.address }}</p>
        </div> -->
    <div class="serve-worker">
      <div class="serve-worker-title pf-medium">服务信息</div>
      <template v-if="isPopYuesao">
        <div
          class="serve-time serve-time-only"
          v-if="hasServiceTime && worker.dateTime"
        >
          <span>预产期</span>
          <span>{{ worker.dateTime }}</span>
        </div>
        <div class="serve-time-tip">
          *系统将在预产期90天后自动确认核销，如您的预产期填写有误，请及时<component
            :is="
              order.inviteInfo && order.inviteInfo.inviteMobile ? 'a' : 'span'
            "
            :href="`tel:${order.inviteInfo && order.inviteInfo.inviteMobile}`"
            >联系育儿顾问</component
          >进行更改
        </div>
      </template>
      <template v-else-if="isApplianceWash">
        <div
          class="serve-time serve-time-only"
          v-if="hasServiceTime && worker.dateTime"
        >
          <span>服务时间</span>
          <span>{{ worker.dateTime }}</span>
        </div>
        <div class="serve-time-tip">
          *如您的服务时间填写有误，请及时
          <component
            :is="order.businessMobile ? 'a' : 'span'"
            :href="`tel:${order.businessMobile}`"
            >联系商家
          </component>
          进行更改
        </div>
      </template>
      <template v-else>
        <div class="item-flex">
          <div class="serve-name" @click.stop="gotoUserDetail(worker)">
            <label class="label-ui">服务人员</label>
            <div class="serve-name-r">
              <img
                :src="worker.headImage | avatar(68, 68)"
                alt=""
                class="avatar"
              />
              <p class="name">{{ worker.workerName }}</p>
            </div>
          </div>
        </div>
        <div class="serve-mes">
          <span>员工信息</span>
          <ul class="serve-mes-tip">
            <li>{{ worker.userType === 1 ? '育儿顾问' : '认证育儿师' }}</li>
            <li v-if="worker.storeName">{{ worker.storeName }}</li>
            <!-- <li>已服务&nbsp;{{worker.servicedTimes}}次</li> -->
          </ul>
        </div>
        <div class="serve-tel" v-show="worker.mobile">
          <div class="serve-tel-content">
            <div class="item-cell-hd">服务人员电话</div>
            <div class="item-cell-bd">
              <a :href="`tel:${worker.mobile}`">{{
                worker.mobile
                  ? worker.mobile.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1 $2 $3')
                  : ''
              }}</a>
            </div>
          </div>
          <a class="telimg" :href="`tel:${worker.mobile}`"></a>
        </div>
        <div class="serve-time" v-if="hasServiceTime && worker.dateTime">
          <span>服务时间</span>
          <span>{{ worker.dateTime }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { SKUTAG } from '@/plugins/enum'

export default {
  props: {
    worker: {
      type: Object,
      default() {
        return {}
      }
    },
    area: {
      type: String,
      default: ''
    },
    order: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    gotoUserDetail(user) {
      if (this.$$isMp()) {
        return
      }
      location.href = `/v/user/${user.uid}`
    },
    getUserID(user) {
      if (user.userType * 1 === 98) {
        if (user.serviceCode && user.spuId) {
          location.href = `/y/worker?empId=${user.serviceCode}&spuId=${user.spuId}`
        }
      } else {
        if (user.yn * 1 === 0 || !user.uid) {
          // 离职
          return
        }
        if (this.$$isMp()) {
          return
        }
        location.href = `/v/user/${user.uid}`
      }
    }
  },
  computed: {
    isPopYuesao() {
      return +this.order.skuTag == SKUTAG.POPYUSAO
    },
    isApplianceWash() {
      return +this.order.skuTag == SKUTAG.APPLIANCE_WASHING
    },
    hasServiceTime() {
      // 打标为实物商品、联营到家的商品 技能培训，不展示服务时间模块， 其他类型商品正常展示
      return +this.order.skuTag == SKUTAG.POPENTITY ||
        +this.order.skuTag == SKUTAG.UNIONHOME ||
        +this.order.skuTag == SKUTAG.POPTRAIN
        ? false
        : true
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.serve-info {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);

  .order-address {
    padding: rem(40px) rem(24px);
    border-radius: rem(16px);
    background: #fff;
    font-size: rem(24px);
    color: #262626;
    line-height: rem(30px);
    margin-bottom: rem(20px);

    &-f {
      display: flex;
      align-items: center;
      font-size: rem(26px);
      color: #262626;
      font-weight: 700;
      height: rem(36px);
      line-height: rem(36px);
      margin-bottom: rem(12px);
    }

    &-s {
      margin-left: rem(44px);
    }

    &-icon {
      display: inline-block;
      background: url('../../assets/images/order/icon-address.png') center
        center;
      background-size: rem(36px) rem(36px);
      width: rem(36px);
      height: rem(36px);
      margin: 0 rem(8px) 0 0;
    }

    &-phone {
      margin-left: rem(16px);
    }
  }

  .serve-worker {
    padding: rem(18px) rem(24px);
    border-radius: rem(16px);
    background: #fff;

    .serve-worker-title {
      font-size: rem(30px);
      padding: rem(14px) 0 0 0;
    }

    .item-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::after {
        content: ' ';
        width: rem(20px);
        height: rem(20px);
        background: url('../../assets/images/order/icon-arr.png') center center;
        background-size: contain;
      }
    }

    .serve-name {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
      padding: rem(22px) 0;
      .serve-name-r {
        display: flex;
        align-items: center;
        .name {
          margin-right: rem(24px);
        }
      }
      .avatar {
        position: relative;
        margin-right: rem(20px);
        width: rem(36px);
        height: rem(36px);
        border-radius: 50%;
      }
    }

    .serve-mes {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: rem(44px);
      font-size: rem(24px);
      color: #808080;
      line-height: rem(28px);
      padding-bottom: rem(20px);

      .serve-mes-tip {
        flex: 1;
        display: flex;
        font-size: rem(24px);
        line-height: rem(28px);
        color: #262626;
        overflow: hidden;
        padding-left: rem(20px);
        justify-content: flex-end;

        li {
          padding-left: rem(13px);
          // margin-left: rem(12px);
          position: relative;
          flex: none;
          @include ellicpsis;
          &:first-child {
            margin-left: 0;
          }
          &:nth-child(2) {
            max-width: rem(350px);
          }
          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 2px;
            height: 2px;
            left: rem(6px);
            top: 50%;
            background-color: #000;
            transform: translateY(-50%);
            border-radius: 50%;
          }
        }
      }
    }

    .serve-tel {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
      padding: rem(22px) 0;
      @include border(top, #f2f2f2);

      .telimg {
        width: rem(34px);
        height: rem(34px);
        border-radius: 50%;
        background: url('../../assets/images/order/icon-tel2.png') center center;
        background-size: rem(34px) rem(34px);
      }

      .serve-tel-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: rem(20px);
      }
    }

    .serve-time {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
      padding: rem(22px) 0;
      @include border(top, #f2f2f2);
    }
    .serve-time.serve-time-only {
      padding: rem(32px) 0 rem(12px);
      @include border(top, transparent);
    }
    .serve-time-tip {
      font-size: rem(22px);
      color: #ff5900;
      line-height: rem(28px);
      padding-bottom: rem(22px);
      a {
        color: #ff5900;
        text-decoration: underline;
        padding-left: rem(30px);
        background: url('../../assets/images/order/icon-tel5.png') rem(5px)
          center/rem(20px) rem(20px) no-repeat;
        font-weight: 500;
      }
    }
  }

  .iconfont {
    font-size: rem(40px);
  }
  .item-cell {
    // align-items: flex-start;
    @include border(bottom);

    &:first-child {
      .item-cell-bd {
        padding-right: rem(100px);
        p:first-of-type {
          font-size: rem(32px);
          font-weight: bold;

          .phone {
            margin-left: rem(15px);
          }
        }
        p:last-of-type {
          margin-top: rem(15px);
          line-height: 1.5;
          color: #666;
        }
      }
    }
    .item-cell-hd {
      // align-self: flex-start;
      align-self: center;
      color: inherit;
    }
    &::after {
      left: rem(20px);
    }
    &:last-child {
      &::after {
        border: 0;
      }
    }
  }
  .show-mobile {
    color: #666;
    font-size: rem(32px);
    a {
      color: inherit;

      &:last-child {
        color: #666;
        font-size: rem(26px);
      }
    }
    .icon-dianhua {
      color: #ff5900;
      margin-left: rem(50px);
      margin-right: rem(10px);
      font-size: rem(30px);
    }
  }
}
</style>
